import request from "../../../axios"
import { citiesData } from "./type"

export const getCitySponsorInformation = async (states: string) => {
    const { data }: { data: citiesData } = await request.get('/api/v2/base/cities-from-states', {
        params: { "state_ids": states }
    })
    return data
}